import { Bell, MapPin, Zap } from 'lucide-react';
import { InstallButton } from '../../components/InstallButton';
import { useInstall } from '../../lib/pwa';
import { useI18n } from '../../i18n';
import { usePublic } from './context';

export function InstallPage() {
  const { restaurant: r } = usePublic();
  const { installed } = useInstall();
  const { t } = useI18n();
  return (
    <main className="pub-main" style={{ maxWidth: 640 }}>
      <div className="card card-pad stack-lg center">
        <img src="/brand/app-icon-192.png" alt="" style={{ width: 112, height: 112, borderRadius: 26, margin: '0 auto', boxShadow: 'var(--shadow)' }} />
        <h1 className="section-title">{t.install.pageTitle(r.name)}</h1>
        <div className="stack" style={{ textAlign: 'left' }}>
          <p className="row">
            <Zap color="var(--red)" /> {t.install.perk1}
          </p>
          <p className="row">
            <MapPin color="var(--red)" /> {t.install.perk2}
          </p>
          <p className="row">
            <Bell color="var(--red)" /> {t.install.perk3}
          </p>
        </div>
        {installed ? <div className="alert alert-success">{t.install.alreadyInstalled}</div> : <InstallButton className="btn btn-primary btn-lg btn-block" appName={r.name} />}
      </div>
    </main>
  );
}
